// extracted by mini-css-extract-plugin
module.exports = {"popper":"header-apps_popper_2BFLX"};